module.exports = __webpack_public_path__ + "img/08@2x.aba61543.png";